<template>
  <div class="vx-row">
    <div class="w-full lg:w-full border border-solid d-theme-border-grey-light rounded">
      <vx-card>
        <div class="vx-row justify-end">
          <div class="flex items-center"  @click="updateProjectPopup=true">
            <vs-button color="dark" type="flat" icon="icon-edit" icon-pack="feather" />
          </div>
          <div class="flex items-center" @click="projectDelete()">
            <vs-button color="danger" type="flat" icon="icon-trash" icon-pack="feather" />
          </div>
        </div>
          <!-- <vs-divider/> -->
        <div class="text-center md:1/3">
          <vs-button class="w-full" color="dark" type="flat" @click="showProject()">
           <div style="text-overflow: ellipsis; width: 100px; overflow: hidden; white-space: nowrap; display: block;">{{projectInfo.title}}</div></vs-button>
        </div>
      </vx-card>
    </div>
    <vs-popup classContent="popup-example" title="" :active.sync="updateProjectPopup" @cancel="clearFields"  @close="clearFields">
      <h4 class="text-center">프로젝트 이름을 변경합니다.</h4> &nbsp;
      <div class="vs-con-input w-full">
        <vs-input icon-pack="feather" color="dark" icon="icon-edit-2" size="large" placeholder="프로젝트명을 입력하세요." v-model="projectTitle" class="is-label-placeholder w-full lg:w-full mb-4" />
        <br/>
        <vs-button class="w-full mb-2" @click="updateProject()" color="primary" type="filled">완료</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  props: ['projectInfo'],
  data () {
    return {
      updateProjectPopup: false,
      projectTitle: ''
    }
  },
  created(){
    this.projectTitle = this.projectInfo.title
  },
  methods: {
    showProject() {      
      this.$store.commit('project/SET_ACTIVE_PROJECT', this.projectInfo)
      this.$router.push('/apps/project/main/'+this.projectInfo.id)
    },
    clearFields() {
      this.$nextTick(() => {
      })
    },
    updateProject(){
      this.$store.dispatch('project/updateProject', {'id':this.projectInfo.id,'title':this.projectTitle})
      .then(()=>{
        this.updateProjectPopup = false
        this.$vs.notify({
          color: 'success',
          title: '완료',
          text: '선택했던 프로젝트를 수정하였습니다.'
        })
      }).catch(() => {
        this.updateProjectPopup = false
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    },
    projectDelete() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `프로젝트 삭제`,
        text: '선택된 프로젝트를 정말 삭제하시겠습니까?',
        accept: this.acceptDeleteAlert
      })
    },
    acceptDeleteAlert() {
      this.$store.dispatch('project/deleteProject', this.projectInfo.id)
      .then(()=>{
        this.$vs.notify({
          color: 'danger',
          title: '프로젝트 삭제 완료',
          text: '선택했던 프로젝트를 삭제하였습니다.'
        })
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '설정 변경 실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    }
  }
}
</script>
